import { apiPost } from '../client';
import { LONG_TIMEOUT_MS } from '../../config/env';
import type { SalesReportFilters, SalesReportResponse } from '../types/salesReports';

/** Bilet Satış Raporu (`Report/TicketJson`, backend Faz D). */
export function getTicketSalesReport(filters: SalesReportFilters): Promise<SalesReportResponse> {
  return apiPost<SalesReportFilters, SalesReportResponse>('Report/TicketJson', filters, {
    timeoutMs: LONG_TIMEOUT_MS,
  });
}

/** Personel Satış Raporu (`Report/PersonelTicketSalesReport`, backend Faz D). Same
 *  request as the ticket report with `isPersonel: true`; legacy defaults filled in. */
export function getPersonnelSalesReport(
  filters: Pick<SalesReportFilters, 'startDate' | 'endDate'>
): Promise<SalesReportResponse> {
  return apiPost<SalesReportFilters, SalesReportResponse>(
    'Report/PersonelTicketSalesReport',
    { ...filters, isPersonel: true, status: 'Booked', providerType: 'Air' },
    { timeoutMs: LONG_TIMEOUT_MS }
  );
}
